export default "__VITE_ASSET__BOmUmg4g__"